import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HotToastService } from "@ngneat/hot-toast";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { Account } from "src/app/dashboard/xero-integration.service";
import { ConversationsService } from "../../conversations.service";
import { MomentModule } from "ngx-moment";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgIf, NgFor, NgClass } from "@angular/common";

@Component({
    selector: "app-xero-client-task-item",
    templateUrl: "./xero-client-task-item.component.html",
    styleUrls: ["./xero-client-task-item.component.scss"],
    imports: [
        NgIf,
        NgFor,
        NgClass,
        TooltipModule,
        FormsModule,
        TypeaheadModule,
        MomentModule,
    ]
})
export class XeroClientTaskItemComponent implements OnInit {
  _xeroTrackedItems = [];
  @Input() set xeroTrackedItems(value: any) {
    value.forEach(
      (v: any) =>
        (v.integration_data.transaction_body = JSON.parse(
          v.integration_data.transaction_body
        ))
    );
    this._xeroTrackedItems = value;
  }

  get xeroTrackedItems() {
    return this._xeroTrackedItems;
  }

  @Input() availableAccounts = [];
  @Input() company: any = null;
  @Input() currentAccount: string = null;
  @Input() type: string = "";

  data: any = null;

  @Output() selectedTrackedItem: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;

  constructor(
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    private toastr: HotToastService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.data = this.localStorageService.get("data");
    console.log("Xero Items", this.xeroTrackedItems);
    console.log("Xero accounts", this.availableAccounts);
  }

  submitAnswer(tracked_item): void {
    this.loading = true;
    this.dashboardService.show_loading.next(true);
    let fileForm = new FormData();

    if (tracked_item.selectedAccount != null) {
      fileForm.append(
        "xero_account",
        JSON.stringify(tracked_item.selectedAccount)
      );
    }

    fileForm.append("tracked_item_id", tracked_item.id);

    console.log({ tracked_item });

    this.conversationsService
      .submit_answer(tracked_item.conversation, fileForm)
      .then(
        (res: any) => {
          this.loading = false;
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          console.log(err);
          this.loading = false;
          this.dashboardService.show_loading.next(false);
        }
      );
  }

  selectAccount(event: any, tracked_item: any) {
    tracked_item.selectedAccount = event.item;
  }

  selectTrackedItem(tracked_item) {
    console.log({ tracked_item });
    this.selectedTrackedItem.emit(tracked_item);

    for (let i = 0; i < this.xeroTrackedItems.length; i++) {
      if (this.xeroTrackedItems[i].id == tracked_item.id) {
        this.xeroTrackedItems[i].selected = true;
      } else {
        this.xeroTrackedItems[i].selected = false;
      }
    }

    tracked_item.selected = true;
  }

  answerTrackedItem(tracked_item, satisfied): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .answer_tracked_item(tracked_item.id, satisfied)
      .then(
        (res: any) => {
          const response = res;
          tracked_item = response.tracked_item;

          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          this.toastr.error(err.error.message);
          this.dashboardService.show_loading.next(false);
        }
      );
  }

  goToXero(bank_transaction_id: string): void {
    window.open(
      `https://go.xero.com/Bank/ViewTransaction.aspx?bankTransactionID=${bank_transaction_id}`,
      "_blank"
    );
  }
}
